// extracted by mini-css-extract-plugin
module.exports = {"banner":"BannerSlider_banner__3Hph9","contentWrap":"BannerSlider_contentWrap__2FBGp","stamp":"BannerSlider_stamp__3pI7Q"};